import { useAppQuery } from "~/hooks/useAppQuery"
import { getPostsFeed } from "../server/feed.functions"
import { feedPostsQueryKey } from "../query-keys"

export function usePosts() {
  return useAppQuery({
    queryKey: feedPostsQueryKey(),
    queryFn: () => getPostsFeed({ data: {} }),
    errorMessage: "Не удалось загрузить посты",
  })
}
